import { BlogCategories } from '@/common/constants/blog';
import { ContentType } from '@/common/constants/ContentTypes';
import { ProductTypes } from '@/common/constants/ProductTypes';
import { SectionNames } from './SectionNames';

export const SectionByContent = {
  [ContentType.RESOURCES]: {
    [BlogCategories.ARTICLES]: [
      SectionNames.IMAGE_TITLE,
      SectionNames.SOCIAL_MEDIA,
      SectionNames.AVATAR,
      SectionNames.TLDR,
      SectionNames.COLLAPSE_BTN,
      SectionNames.BODY,
      SectionNames.REACTIONS,
      SectionNames.COMMENTS,
      SectionNames.RELATED_GROUPS,
    ],
    [BlogCategories.VIDEOS]: [
      SectionNames.VIDEO,
      SectionNames.SOCIAL_MEDIA,
      SectionNames.AVATAR,
      SectionNames.TLDR,
      SectionNames.REACTIONS,
      SectionNames.COMMENTS,
      SectionNames.RELATED_GROUPS,
    ],
    [BlogCategories.REAL_LIFE_STORIES]: [
      SectionNames.IMAGE_TITLE,
      SectionNames.SOCIAL_MEDIA,
      SectionNames.AVATAR,
      SectionNames.TLDR,
      SectionNames.BODY,
      SectionNames.REACTIONS,
      SectionNames.COMMENTS,
      SectionNames.RELATED_GROUPS,
    ],
  },
  [ContentType.PRODUCTS]: {
    [ProductTypes.DEFAULT]: [
      SectionNames.PRODUCT_CAROUSEL,
      SectionNames.PURCHASE,
      SectionNames.COLLAPSE_BTN,
      SectionNames.AVATAR,
      SectionNames.TLDR,
      SectionNames.BODY,
      SectionNames.COLLAPSE_BTN,
      SectionNames.REACTIONS,
      SectionNames.COMMENTS,
      SectionNames.RELATED_GROUPS,
    ],
  },
  [ContentType.DISCUSSIONS]: {
    default: [
      SectionNames.TITLE,
      SectionNames.AVATAR,
      SectionNames.TLDR,
      SectionNames.SOCIAL_MEDIA,
      SectionNames.COMMENTS,
      SectionNames.RELATED_GROUPS,
    ],
  },
};
